import Vue from 'vue'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_STATES,
  RECEIVING_STATES,
  RECEIVE_STATE_METADATA,
  RECEIVE_STATE_FAILURE,
  SAVING_STATE,
  SAVING_STATE_FAILURE,
  UPDATING_STATE,
  UPDATING_STATE_FAILURE,
  DELETE_STATE,
  DELETING_STATE,
  DELETING_STATE_FAILURE,
  CLEAR_STATE_STATE,
  RESET_STATE_META,
  CLEAR_STATE,
  INCREMENT_STATE_COUNT
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import handleXHRError from '@/utils/helpers/HandleXHRError'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const stateSchema = new schema.Entity('states')
const stateListSchema = new schema.Array(stateSchema)

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  saveFailure: null,
  receivingData: false,
  receiveDataFailure: false,
  updating: null,
  updateFailure: null,
  deleting: false,
  deleteFailure: null
}

const actions = {
  fetchStatesWithQuery (store, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_STATES, true)
    return Vue.http.get(buildUrlWithQuery('states', query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        this.commit(RECEIVING_STATES, false)
        this.commit(RESET_STATE_META)
        if (!r.hasOwnProperty('results')) return this.commit(RECEIVE_STATE_FAILURE, 'Error fetching states')
        const { results, next, previous, count } = r
        const { entities, result } = normalize(results, stateListSchema)
        this.commit(RECEIVE_STATES, { data: entities.states })
        this.commit(RECEIVE_STATE_METADATA, { next, previous, count, result: result.length })
        return { query, count, entities }
      })
      .catch(e => {
        this.commit(RECEIVING_STATES, false)
        this.commit(RECEIVE_STATE_FAILURE, handleXHRError(e))
      })
  }
}

const getters = {
  getStates: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllStates: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getStateMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getStateById: (state) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getStateFetchStatus: (state) => {
    return state.receivingData
  },
  getStateSaveStatus: (state) => {
    return state.saving
  },
  getStateUpdateStatus: (state) => {
    return state.updating
  },
  getStateDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_STATES] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_STATES] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_STATE_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [SAVING_STATE] (state, payload) {
    state.saving = payload
  },
  [SAVING_STATE_FAILURE] (state, payload) {
    state.saveFailure = payload
  },
  [UPDATING_STATE] (state, payload) {
    state.updating = payload
  },
  [UPDATING_STATE_FAILURE] (state, payload) {
    const { id, err } = payload
    state.updateFailure = { id, err }
  },
  [DELETE_STATE] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_STATE] (state, payload) {
    state.deleting = payload
  },
  [DELETING_STATE_FAILURE] (state, payload) {
    const { id, err } = payload
    state.deleteFailure = { id, err }
  },
  [INCREMENT_STATE_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_STATE_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_STATE_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_STATE_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/state.js